import { firebase, googleAuthProvider } from "../firebase/firebase-config";
import { types } from "../types/types"
import { finishLoading, startLoading } from "./ui";
import Swal from 'sweetalert2'
import { noteLogout } from "./notes";


export const startLoginEmailPassword = (email, password) => {
    return (dispatch) => {
        dispatch(startLoading())
        firebase.auth().signInWithEmailAndPassword(email, password).then(({ user }) => {
            dispatch(login(user.uid, user.displayName))
        }).catch(err => {
            console.log(err)
            Swal.fire('Error', err.message, 'error')
        }).finally(() => dispatch(finishLoading()))
    }
}
export const startRegisterWithEmailPasswordName = (email, password, name) => {
    return (dispatch) => {
        firebase.auth().createUserWithEmailAndPassword(email, password).then(async ({ user }) => {
            await user.updateProfile({ displayName: name })
            dispatch(login(user.uid, user.displayName))
        }).catch(err => {
            console.log(err)
        })

    }
}
export const startGoogleLogin = () => {
    //Thunk me va a proveer el dispatch de forma que cuando ya tenga la información 
    //voy a lanzar la acción
    return (dispatch) => {
        firebase.auth().signInWithPopup(googleAuthProvider).then(({ user: { displayName, uid } }) => {
            dispatch(login(uid, displayName))
        })
    }
}

export const login = (uid, displayName) => (
    {
        type: types.login,
        payload: {
            uid,
            displayName
        }
    }
)

export const startLogout = () =>{
    return async (dispatch) =>{
        await firebase.auth().signOut();

        dispatch(logout())
        dispatch(noteLogout())
    }
}

export const logout = () =>{
    return {
        type:types.logout
    }
}